import useMap from "../../components/useMap";
import useSelectedFeatures from "../../components/maps/GeoJSONMap/useSelectedFeatures";
import {useGeoJSONStations} from "../../components/maps/query";


const useStationsMap = ({stationsFilters}) => {
    const geoStationQuery = useGeoJSONStations(stationsFilters);
    const stationGeoJSON = geoStationQuery.data ?? {type: "FeatureCollection", features: []};
    const map = useMap();
    const selectedFeatures = useSelectedFeatures({features: stationGeoJSON.features});

    return {
        geoJSON: stationGeoJSON,
        ...map,
        ...selectedFeatures,
    }
}


export default useStationsMap;